import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS, faqJsonLd } from "@/data/content";

const Faq = () => (
  <>
    <SEO
      title="FAQ — STD, HIV & Sexual Health Questions | Delhi STD Clinic, Dr. Ankur Lal"
      description="Answers to common questions about confidential STD consultation, HIV PEP timing, STI testing, online consultation and treatment — Delhi STD Clinic, Dr. Ankur Lal."
      path="/faq"
      jsonLd={faqJsonLd}
    />
    <PageHero
      eyebrow="Questions, Answered Honestly"
      title="Frequently Asked Questions"
      intro="Medically responsible answers — without judgment, and without false promises. For advice about your own situation, book a confidential consultation."
    />

    <section className="py-14 sm:py-20" data-testid="faq-list">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Accordion type="single" collapsible>
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-medium text-slate-900">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <p className="text-sm text-slate-500 leading-relaxed bg-secondary border border-amber-600/20 rounded-2xl p-5">
            These answers are general medical information, not individualized medical
            advice. Your own care may differ based on clinical assessment — a consultation
            is the right way to get advice specific to you.
          </p>
        </Reveal>
      </div>
    </section>

    <CtaBand
      title="Still Have a Question?"
      text="Ask Dr. Ankur Lal directly — privately, and without judgment."
    />
  </>
);

export default Faq;
